export default __webpack_public_path__ + "static/media/logo.9ee49a6c.png";